export class AttachmentFilter {
    entityType: string;
	entityId: number;
}